import { Icon } from '@/components/icons/Icon'
import { cn } from '@/utils/commonUtil'

import styles from './LoadingMask.module.scss'

type Props = {
  allowClicks?: boolean
  bgNone?: boolean
  blurNone?: boolean
  borderRadius?: string
  loading?: boolean
  showShimmer?: boolean
  showSpinner?: boolean
  zIndex?: string
}

export const LoadingMask = ({
  allowClicks,
  bgNone,
  blurNone,
  borderRadius,
  loading,
  showShimmer = true,
  showSpinner,
  zIndex,
}: Props) => {
  const style = {
    ...(borderRadius && { '--border-radius': borderRadius }),
    ...(zIndex && { '--z-index': zIndex }),
  } as React.CSSProperties

  return (
    <div
      aria-busy={loading}
      className={cn(styles.container, {
        allowClicks,
        bgNone,
        blurNone,
        loading,
        showShimmer,
        styles,
      })}
      role='alert'
      style={style}
    >
      {showSpinner && (
        <span className={styles.icon}>
          <Icon name='spinner' />
        </span>
      )}
    </div>
  )
}
